import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageResolveService implements Resolve<any> {

  constructor(
    private translateService: TranslateService,
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    if(this.translateService.currentLang == 'en') {
      if(route.queryParams['lang'] == 'zh') {
        this.translateService.use('zh')
      }
      else {
        this.translateService.use('en')
      }
    }
    return
  }
}
